import { Card, CardContent, Container, Stack } from '@mui/material';
import React from 'react';

import BlueCorner from '@components/BlueCorner/';
import ContentLoader from '@components/ContentLoader';
import Seo from '@components/SEO';

import { AuthenticationStyle, Title } from './AuthLayout.style';

export default function AuthLayout({
  title = '',
  loading = false,
  bottomContent = null,
  children = null,
}: {
  title?: string;
  loading?: boolean;
  bottomContent?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <AuthenticationStyle>
      <Seo title={title} />
      <BlueCorner />
      <Container
        maxWidth="xs"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <Stack sx={{ width: '100%' }}>
          <Card>
            <CardContent>
              {title ? <Title>{title}</Title> : null}
              <ContentLoader loading={loading}>{children}</ContentLoader>
            </CardContent>
          </Card>
          {bottomContent}
        </Stack>
      </Container>
    </AuthenticationStyle>
  );
}
